<div class="relative flex h-[480px] w-96 max-w-lg flex-col rounded-2xl bg-background-white/40 p-5 pb-6 shadow-modal backdrop-blur-modal">
  <!-- Fixed Header with Title and Close Button -->
  <div class="flex items-center justify-between pb-6">
    <h2 class="text-xl font-semibold text-text-primary">
      {{ 'schedule_legend_title' | translate }}
    </h2>
    <button class="flex h-6 w-6 items-center justify-center rounded-full" (click)="onCloseDialog()" type="button">
      <svg-icon key="px-16-x" class="h-6 w-6 text-primary-blue" />
    </button>
  </div>

  <!-- Scrollable Content -->
  <div class="-mr-3 flex-1 overflow-y-auto pr-3">
    <div>
      <!-- Appointment Card Example -->
      <div class="mb-6">
        <img src="assets/images/schedule_legend.png" [alt]="'schedule_legend_appointment_card_example' | translate" class="w-full" />
      </div>

      <!-- Appointment Status List -->
      <div class="mb-6">
        <h3 class="typo-h8-semibold mb-3 text-text-primary">
          {{ 'schedule_legend_appointment_status' | translate }}
        </h3>
        <div class="grid grid-cols-2 gap-x-4 gap-y-[6px]">
          @for (status of appointmentStatusColors; track status.dxStatusId) {
            <div class="flex items-center justify-center gap-[2px]">
              <div class="h-[10px] w-1 flex-shrink-0" [style.background-color]="convertToHexColor(status)"></div>
              <span class="typo-h8-light font-normal uppercase text-text-primary">
                {{ status.statusCode }}
              </span>
              <span class="typo-h9-light grow text-right text-text-secondary">
                {{ status.statusName }}
              </span>
            </div>
          } @empty {
            <span class="typo-h9-light"> - </span>
          }
        </div>
      </div>

      <!-- Provider List -->
      <div class="mb-6">
        <h3 class="typo-h8-semibold mb-3 text-text-primary">
          {{ 'schedule_legend_providers' | translate }}
        </h3>
        <div class="grid grid-cols-2 gap-x-4 gap-y-[6px]">
          @for (provider of providers; track provider.id) {
            <div class="flex items-center justify-center gap-[2px]">
              <div class="h-[10px] w-[8px] rounded-[4px_1px_1px_1px]" [style.background-color]="formatProviderColor(provider.color)"></div>
              <span class="typo-h8-light font-normal uppercase text-text-primary">
                {{ provider.pmsId }}
              </span>
              <span class="typo-h9-light grow text-right text-text-secondary"> {{ provider.firstName }} {{ provider.lastName }} </span>
            </div>
          } @empty {
            <span class="typo-h9-light"> - </span>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Gradient Bottom -->
  <div class="absolute bottom-0 left-0 right-0 h-12 rounded-b-2xl bg-gradient-to-b from-transparent to-background-white"></div>
</div>
